module.exports = function getResource(label) {
    let resources = {
        flashTermsConditionsLabel: 'FLASH Terms & Conditions (Required)',
        flashRenewsUnlessCancelMessage: 'I acknowledge that Sephora FLASH is a non-refundable subscription service that automatically renews every 12 months unless I cancel.'
    };

    return resources[label];
};
